import { signInWithEmailAndPassword } from "firebase/auth";
import { auth } from "../firebase";

export class AuthResult {
    private _isSuccess: boolean;
    private _message: string | null;

    constructor(isSuccess: boolean, message: string | null) {
        this.setSuccess(isSuccess);
        this.setMessage(message);
    }

    public setSuccess(value: boolean) {
        this._isSuccess = value;
    }
    public setMessage(value: string | null) {
        this._message = value;
    }

    public getSuccess(): boolean {
        return this._isSuccess;
    }
    public getMessage(): string | null {
        return this._message;
    }
}

export async function signOut(clean: boolean = false) {
    await auth.signOut();
    var href = '/login';
    if (!clean) {
        href = `${href}?redirect=${window.location.pathname}`;
    }
    document.location.href = href;
}

export async function signIn(email: string, password: string):Promise<AuthResult> {
    try {
        await signInWithEmailAndPassword(auth, email, password);

        return new AuthResult(true, null);
    } catch (e) {
        return new AuthResult(false, e.message);
    }
}